import styled from 'styled-components';

const Link = styled.a`
  color: #000;
  text-decoration: underline;
  ${props => (props.fontSize ? `font-size: ${props.fontSize}` : null)};
`;

export default Link;
